import {
  loginByPassword,
  getUserInfoBySession,
  getUserInfoBySessionPost,
  logout,
  loginbyId
} from '@/api/common/login'
import { getToken, removeToken } from '@/utils/token'
import {
  sendCertificateNumber,
  saveUsers,
  getMyMenu,
  registUser
} from '@/api/common/user'
import EventHandler from '@/utils/eventHandler'
import logger from '@/utils/log'
import store from '@/store'

import localStore from '@/utils/localStore'
import Message from '@/utils/message'

export default {
  state: {
    userId: '',
    userName: '',
    token: '',
    roles: [],
    registName: '',
    registPhoneNumber: '',
    buttonPermission: '',
    myMenu: []
  },
  mutations: {
    SET_USER_ID: (state, userId) => {
      state.userId = userId
      localStore.set('userId', userId)
    },
    SET_USER_NAME: (state, userName) => {
      state.userName = userName
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_REGIST_NAME: (state, registName) => {
      state.registName = registName
    },
    SET_REGIST_PHONE_NUMBER: (state, registPhoneNumber) => {
      state.registPhoneNumber = registPhoneNumber
    },
    SET_BUTTON_PERMISSION: (state, buttonPermission) => {
      state.buttonPermission = buttonPermission
    },
    SET_MY_MENU: (state, myMenuList) => {
      state.myMenu = myMenuList
    },
    SET_SITE_CNT: (state, site_cnt) => {
      state.site_cnt = site_cnt
    },
    SET_SITE_ID: (state, site_id) => {
      state.site_id = site_id
    },
    SET_GRP_AUTH: (state, grp_auth) => {
      state.grp_auth = grp_auth
      localStore.set('grp_auth', grp_auth)
    },
    SET_ADMIN: (state, admin) => {
      state.admin = admin
      localStore.set('admin', admin)
    },
    SET_PW_CHANGE: (state, pw_change) => {
      localStore.set('pw_change', pw_change)
    },
    SET_LOGIN_COUNT: (state, login_count) => {
      localStore.set('login_count', login_count)
    },
    SET_EMAIL: (state, email) => {
      localStore.set('email', email)
    },
    SET_USER_PCOMPANY: (state, userPcompany) => {
      if (userPcompany !== null) {
        localStore.set('userPcompany', userPcompany)
      } else {
        localStore.set('userPcompany', '')
      }
      state.userPcompany = userPcompany
    }
  },
  actions: {
    loginbyId({ commit }, userInfo) {
      // API를 통해 입력 받은 ID/Password 정보를 입력한다.
      return new Promise((resolve, reject) => {
        loginbyId(userInfo.userId)
          .then(response => {
            // login 결과 받아온 User Information을 store에 저장한다.
            // console.log('response :', response)
            // cookie에 토큰값 저장, 토큰값이 따로 없을 경우, userId로 처리
            commit('SET_TOKEN', getToken())
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    LoginByPassword({ commit }, userInfo) {
      // API를 통해 입력 받은 ID/Password 정보를 입력한다.
      return new Promise((resolve, reject) => {
        loginByPassword(userInfo.userId, userInfo.userPassword)
          .then(response => {
            // login 결과 받아온 User Information을 store에 저장한다.
            // console.log('response :', response)
            // cookie에 토큰값 저장, 토큰값이 따로 없을 경우, userId로 처리
            commit('SET_TOKEN', getToken())
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // SetUserInfo({ commit }) {
    //   // API를 통해 세션정보로 User 정보를 가져와 store에 반영
    //   return new Promise((resolve, reject) => {
    //     getUserInfoBySession()
    //       .then(response => {
    //         // console.log('[SetUserInfo] response :', response)
    //         // 받아오는 값이 Array일 경우
    //         response = Array.isArray(response) ? response[0] : response
    //         commit('SET_USER_ID', response['user_id'])
    //         commit('SET_USER_NAME', response['kor_nm'])
    //         commit('SET_TOKEN', getToken())
    //         if (response['roles']) {
    //           commit('SET_ROLES', response['roles'])
    //         } else if (response['user_id'] === 'admin') {
    //           commit('SET_ROLES', ['admin'])
    //         }
    //         // 차후 유저 정보를 가져와 반영해야할 항목은 여기서 정의
    //         // 버튼 퍼미션 정보 가져와서 저장
    //         getButtonPermission()
    //           .then(response => {
    //             logger.info('Call Permission', response)
    //             // 불러왔을 경우, 없으면 초기화 한다.
    //             if (Array.isArray(response) === false) response = []
    //             commit('SET_BUTTON_PERMISSION', response)
    //             EventHandler.emit('loaded-permission')
    //           })
    //           .catch(() => {
    //             // catch를 작성해야 그 다음 then이 실행됨
    //           })
    //           .then(() => {
    //             resolve()
    //           })
    //       })
    //       .catch(error => {
    //         reject(error)
    //       })
    //   })
    // },
    SetUserInfo({ commit }) {
      // API를 통해 세션정보로 User 정보를 가져와 store에 반영
      return new Promise((resolve, reject) => {
        getUserInfoBySessionPost()
          .then(response => {
            // console.log('[SetUserInfo] response :', response)
            // 받아오는 값이 Array일 경우

            response = Array.isArray(response) ? response[0] : response

            if (
              response['grp_auth'] !== 'usergroup001' &&
              response['grp_auth'] !== 'usergroup002' &&
              response['grp_auth'] !== 'usergroup004' &&
              response['site_cnt'] == 0
            ) {
              if (response['user_id'] !== undefined) {
                Message.warn(
                  '연결된 사이트 정보가 없습니다. 관리자에게 문의 바랍니다.'
                )
                return
              }
            }
            if (response['user_id'] === undefined) {
              return
            }
            commit('SET_USER_ID', response['user_id'])
            commit('SET_USER_NAME', response['kor_nm'])
            commit('SET_TOKEN', getToken())
            if (response['roles']) {
              commit('SET_ROLES', response['roles'])
            } else if (response['user_id'] === 'admin') {
              commit('SET_ROLES', ['admin'])
            }
            if (
              response['grp_auth'] === 'usergroup001' ||
              response['grp_auth'] === 'usergroup002' ||
              response['grp_auth'] === 'usergroup003' ||
              response['grp_auth'] === 'usergroup004'
            ) {
              commit('SET_ADMIN', 'true')
            } else {
              commit('SET_ADMIN', 'false')
            }
            commit('SET_SITE_CNT', response['site_cnt'])
            commit('SET_SITE_ID', response['site_id'])
            commit('SET_GRP_AUTH', response['grp_auth'])
            commit('SET_USER_PCOMPANY', response['pcompany'])
            commit('SET_PW_CHANGE', response['pw_change'])
            commit('SET_LOGIN_COUNT', response['login_count'].toString())
            commit('SET_EMAIL', response['email'])

            // console.log(localStore.get('userPcompany'))
            // 차후 유저 정보를 가져와 반영해야할 항목은 여기서 정의
            EventHandler.emit('loaded-permission')
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    Logout({ dispatch }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          dispatch('ClearSession')
          localStore.set('userPcompany', '')
          localStore.set('userId', '')
          localStore.set('grp_auth', '')
          resolve()
        })
      })
    },
    ClearSession({ commit }) {
      commit('SET_USER_ID', '')
      commit('SET_USER_NAME', '')
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_SITE_CNT', '')
      commit('SET_SITE_ID', '')
      commit('SET_GRP_AUTH', '')
      commit('SET_PW_CHANGE', '')
      commit('SET_ADMIN', 'false')
      commit('SET_USER_PCOMPANY', '')
      removeToken()
    },
    SendCertificateNumber({ commit }, certificateInfo) {
      return new Promise((resolve, reject) => {
        // 인증번호 발송 API를 호출한다.
        // 호출 성공시 입력된 사용자 정보 를 state 영역에 담아놓는다.
        // 회원가입시 기본 고정값으로 셋팅하기 위함
        sendCertificateNumber(
          certificateInfo.name,
          certificateInfo.fromPhoneNumber,
          certificateInfo.toPhoneNumber,
          certificateInfo.createType
        )
          .then(response => {
            commit('SET_REGIST_NAME', certificateInfo.name)
            commit('SET_REGIST_PHONE_NUMBER', certificateInfo.toPhoneNumber)
            resolve(response)
          })
          .catch(error => {
            // 호출 실패시 state 값 초기화
            commit('SET_REGIST_NAME', '')
            commit('SET_REGIST_PHONE_NUMBER', '')
            reject(error)
          })
      })
    },
    RegistUser({ commit }, saveData) {
      console.log('saveData !!!', saveData)
      return new Promise((resolve, reject) => {
        // 회원가입이 완료되면 store 내 인증 관련 정보를 초기화한다.
        registUser(saveData)
          .then(response => {
            commit('SET_REGIST_NAME', '')
            commit('SET_REGIST_PHONE_NUMBER', '')
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    GetMyMenu({ commit }, userId) {
      return new Promise((resolve, reject) => {
        // 회원가입이 완료되면 store 내 인증 관련 정보를 초기화한다.
        getMyMenu(userId)
          .then(response => {
            commit('SET_MY_MENU', response)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}
